import { render } from "./MyEmailAddress.vue?vue&type=template&id=7a53e3ee"
import script from "./MyEmailAddress.vue?vue&type=script&lang=js"
export * from "./MyEmailAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__